import React from 'react'
import { useSearchConditionMobile } from '../hooks/useSearchCondition'
import { CheckList, CheckListProps } from 'antd-mobile'
import { LabelItem } from '../Common/LabelItem'
import { FilterList } from '../Common/FilterList'
import { SearchConditionsParams,SearchConditionsResponse,SearchConditionsResponseItem} from '@/component/FilterCommon/hooks/useSearchCondition';
import _ from 'lodash'

export interface FilterCommonSearchConditionPropsMobile<T extends SearchConditionsParams = SearchConditionsParams> {
  value?: Array<string|number>
  placeholder: string
  onChange(value:any): void
  searchCondition: T
  getSearchConditionValue: (params: Partial<SearchConditionsResponse<T>>) => SearchConditionsResponseItem[]
  addAllChildren?: boolean
}
export const FilterFilterCommonSearchConditionMobile = <T  extends SearchConditionsParams >(props: FilterCommonSearchConditionPropsMobile<T>) => {

  const { value, placeholder, ...reset } = props
  const { searchCondition, visible, loading, getInitData, toggle } = useSearchConditionMobile(props.searchCondition)
  let options = props.getSearchConditionValue(searchCondition)
  return <div>
    <LabelItem
      label={placeholder}
      options={options}
      value={value}
      addAllChildren={props.addAllChildren}
      onClick={() => {
        toggle()
      }}
    />
    <FilterList
      loading={loading}
      value={ value }
      dataSource={ options || []}
      onChange={props?.onChange}
      headerText={placeholder}
      visible={visible}
      onClose={toggle}
      addAllChildren={props.addAllChildren}
      hideSearch
    />
  </div>

}
